/**
 * @file
 * prevent_speedbump_bypass.
 * 
 */
function clickProcedure(e) {
  if (e.which == 2) {
    e.preventDefault();
  }
}

(function (Drupal) {
  Drupal.behaviors.prevent_speedbump_bypass = {
    attach: () => {
      document.addEventListener("click", clickProcedure); //This one will work on Firefox
      document.addEventListener("auxclick", clickProcedure); //This one will work on Chrome
    }
  }
})
